import Helpers from "../../commons/helpers";
import { IManageUser, IUser } from "../../commons/interfaces";
import { Constants } from "../../constants/constants";
import { IPagedList } from "./../../commons/interfaces";
import IdentityClient from "./IdentityClient";

export interface IRequestGetPagedUser {
    orderby?: string;
    pageSize?: number;
    pageNumber?: number;
    totalCount?: number;

    clientId?: string;
    serviceCode?: string;
    organizationId?: string | number;

    groupId?: string;
    fullName?: string;
    roleCode?: string;
    searchText?: string;
    listStatus?: number[];
    selectedIds?: string[];
}

export interface IDataRequestCreateUpdateUser {
    clientId?: string;
    tenantCode?: string;
    serviceCode?: string;
    organizationId?: string;

    id?: string;
    email?: string;
    gender?: number;
    userName?: string;
    password?: string;
    fullName?: string;
    avatarId?: string;
    avatarUrl?: string;
    isActive?: boolean;
    phoneNumber?: string;
    birthDate?: string | number;

    roleCodes?: string[];
    userGroups?: {
        id?: string;
        groupId?: string;
        userTitle?: string;
        manager?: number;
        default?: number;
        action?: number;
    }[];
    organizationUserProfile?: {
        id?: string;
        email?: string;
        gender?: number;
        userType?: number;
        lastName?: string;
        firstName?: string;
        phoneNumber?: string;
        dateOfBirth?: string | number;
        employmentDate?: string | number;
        terminationtDate?: string | number;

        idCardNo?: string;
        idCardIssuedDate?: string | number;
        idCardIssuedPlace?: string;
        socialInsuranceCode?: string;

        extraInformationObject?: {
            description?: string;
        };

        organizationUserDocuments?: {
            id?: string;
            action?: number;
            fileId?: string;
            fileUrl?: string;
            sequence?: number;
            userProfileId?: string;
            documentGroup?: string;
        }[];
    };
}

const UserService = {
    async getPaged(data: IRequestGetPagedUser): Promise<IPagedList<IUser>> {
        const query = Helpers.handleFormatParams({ ...data, totalCount: undefined });
        const result = await IdentityClient().get(`${Constants.ApiPath.USER.GET_PAGED}?${query}`);
        return result.data.result;
    },
    async getServiceUserPaged(data: IRequestGetPagedUser): Promise<IPagedList<IUser>> {
        const query = Helpers.handleFormatParams({ ...data, totalCount: undefined });
        const result = await IdentityClient().get(`${Constants.ApiPath.USER.GET_SERVICE_USER_PAGED}?${query}`);
        return result.data.result;
    },

    async getDetail(data: { id: string; clientId?: string; organizationId?: string }): Promise<IUser> {
        const result = await IdentityClient().get(`${Constants.ApiPath.USER.DETAIL}?${Helpers.handleFormatParams(data)}`);
        return result.data.result;
    },

    async create({ data, newDomain }: { data: IDataRequestCreateUpdateUser; newDomain?: string }) {
        const result = await IdentityClient(newDomain).post(Constants.ApiPath.USER.CREATE, data);
        return result.data;
    },

    async update({ data, newDomain }: { data: IDataRequestCreateUpdateUser; newDomain?: string }) {
        const result = await IdentityClient(newDomain).post(Constants.ApiPath.USER.UPDATE, data);
        return result.data;
    },

    async delete(data: any) {
        const result = await IdentityClient().delete(Constants.ApiPath.USER.DELETE, { data });
        return result.data;
    },

    async updateStatus(data: any) {
        const result = await IdentityClient().post(Constants.ApiPath.USER.UPDATE_STATUS, data);
        return result.data;
    },

    async getManageUser(): Promise<IManageUser[]> {
        const result = await IdentityClient().get(Constants.ApiPath.USER.GET_MANAGE_USER);
        return result.data.result;
    },
};

export default UserService;

// interface IRecordUser {
//     userName: string
//     fullName: string
//     email: string
//     phoneNumber: string
//     avatarUrl: string
//     avatarId: string
//     organizationUserProfile: IOrganizationUserProfile
//     organizationProfiles: any
//     groups: any
//     userRoles: IUserRole[]
//     groupUsers: IGroupUser[]
//     invitation: {
//         id: string
//         status: number
//         invitedUserId: string
//         validTo: string
//         validFrom: string
//         invitationDetails: any
//         roleNames: string[]
//         groupNames: IMultiLanguageContent[]
//         resourceNames: any
//     },
//     id: string
//     status: number
//     createTime: string
//     createUser: string
//     updateTime: string
//     updateUser: string
// }

// export interface IOrganizationUserProfile {
//     userId: string
//     organizationId: string
//     userType: number
//     userCode: string
//     firstName: string
//     lastName: string
//     dateOfBirth: string
//     gender: number
//     employmentDate: string
//     terminationtDate: string
//     idCardNo: string
//     idCardIssuedDate: string
//     idCardIssuedPlace: string
//     socialInsuranceCode: string
//     extraInformation: string
//     activeStatus: number
//     email: string
//     phoneNumber: string
//     passportNo: string
//     passportExpiredDate: string
//     passportIssuedPlace: string
//     nationality: string
//     id: string
//     status: number
//     createTime: string
//     createUser: string
//     updateTime: string
//     updateUser: string
// }

// export interface IGroupUser {
//     groupName: IMultiLanguageContent
//     organizationId: string
//     organizationName: any
//     groupId: string
//     userId: string
//     userTitle: string
//     startTime: string
//     endTime: string
//     manager: number
//     default: number
//     id: string
//     status: number
//     createTime: string
//     createUser: string
//     updateTime: string
//     updateUser: string
// }

// export interface IUserRole {
//     tenantName: any
//     serviceName: any
//     organizationId: any
//     roleId: string
//     roleName: string
//     roleType: number
//     roleLevel: number
//     userId: string
//     tenantCode: any
//     serviceCode: string
//     groupId: string
//     roleCode: string
//     title: any
//     startTime: string
//     endTime: string
//     activeStatus: number
//     id: string
//     status: number
//     createTime: any
//     createUser: any
//     updateTime: any
//     updateUser: any
// }
